export const trackingEvents = {
  DOWNLOAD_CSV: {
    CLICKED: 'auto_offer_rate.download_csv.clicked',
  },
}
